import { Injectable } from '@angular/core';

import { SessionStorageService } from '../core/sessionstorage.service';
import { ParamService } from './param.service';
import { UserRole, ParamId } from './enumtype';

import { ParamInfo } from './paraminfo.model';

import { Store } from '@ngrx/store';
import { CreateParameter, ClearParameter, UpdateParameter } from '../statemanagement/action/parameter.actions';
import { AppState } from '../statemanagement/app.state';

@Injectable()
export class ParameterConfigService {

    constructor(
        private storageService: SessionStorageService,
        private paramService: ParamService,
        private store: Store<AppState>
    ) { }

    public enableLink(): boolean {
        if (this.storageService.getUserRole() === UserRole.Citizen)
            return true;
        else
            return false;
    }

    // To load the System Paramter Values
    LoadSystemParams(jurisNo: number) {
        this.paramService.getParamInfo(jurisNo)
            .then(res => {
                this.SetSystemParamValue(res);
            })
            .catch(err => { throw err; });
    }

    // To get the specific System Parameter value based on the ParamId
    //GetSystemParamValue(paramId: number) {
    //    let paramInfo: ParamInfo[];
    //    let paramValue: any;

    //    paramInfo = this.storageService.getParamInfo();
    //    paramValue = paramInfo ? (paramInfo.filter(x => x.ParamID === paramId)[0] ? paramInfo.filter(x => x.ParamID === paramId)[0].DefaultValue : null) : null;

    //    if (paramId === ParamId.TaxiCompliant && (paramValue == 'true' || this.storageService.getUserRole() === UserRole.Citizen)) {
    //        paramValue = true;
    //    }
    //    else if (paramId === ParamId.TaxiCompliant) {
    //        paramValue = false;
    //    }
        
    //    return paramValue;
    //}

    GetSystemParamValue(paramId: number) {

        let paramInfo: ParamInfo[];
        let paramValue: any;

        this.store.select("parameter").subscribe(paramObject => {
            if (paramObject) {
                paramInfo = paramObject["0"];
                paramValue = paramInfo ? (paramInfo.filter(x => x.ParamID === paramId)[0] ? paramInfo.filter(x => x.ParamID === paramId)[0].DefaultValue : null) : null;
            }
        });

        if (paramId === ParamId.TaxiCompliant && (paramValue == 'true' || this.storageService.getUserRole() === UserRole.Citizen)) {
            paramValue = true;
        }
        else if (paramId === ParamId.TaxiCompliant) {
            paramValue = false;
        }
        return paramValue;
    }

    // To get the specific System Parameter objects based on the ParamId
    //GetSystemParamInfo(paramId: number) {
    //    let paramInfo: ParamInfo;
    //    let paramInfoArray: ParamInfo[];
    //    paramInfo = this.storageService.getParamInfo() ? this.storageService.getParamInfo().filter(x => x.ParamID === paramId)[0] : null;
    //    return paramInfo;
    //}

    GetSystemParamInfo(paramId: number) {
        let paramInfo: ParamInfo;
        let paramInfoArray: ParamInfo[];

        this.store.select("parameter").subscribe(paramObject => {
            if (paramObject) {
                paramInfoArray = paramObject["0"];
                paramInfo = paramInfoArray.filter(col => col.ParamID == paramId)[0];
            }
        });

        return paramInfo;
    }

    // Added by Punitavathy to update system parameter value in session whenever changed
    //SetSystemParamValue(paramInfo: ParamInfo[]) {
    //   this.storageService.setParamInfo(paramInfo);
    //}
    UpdateParamValue(paramInfo: ParamInfo[]) {
        this.store.dispatch(new UpdateParameter(paramInfo));
    }
    SetSystemParamValue(paramInfo: ParamInfo[]) {
        if (paramInfo) {
            for (let i = 0; i < paramInfo.length; i++) {

                if (paramInfo[i].ParamID == 102) {
                    if (paramInfo[i].DefaultValue != null || paramInfo[i].DefaultValue != undefined) {
                        localStorage.setItem('isNibrs', paramInfo[i].DefaultValue.toString())
                    }
                }
            }
        }
        this.store.select("parameter").subscribe(paramObject => {
            if (!paramObject) {
                this.store.dispatch(new CreateParameter(paramInfo));
            }
        });
    }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/parameterconfig.service.ts